import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { contains, call, either, equals, uniq, always, not, cond, prop, isEmpty, isNil } from 'ramda';
import { DropDownMenu, MenuItem } from 'material-ui';

const notEqual = (first, second) => not(equals(first, second));
const isNilOrEmpty = either(isEmpty, isNil);

const Filter = props => {
  const {
    updateMMProp,
    filterByMediaType,
    updateStateForViewers,
    isEditable,
    isSupplier,
    forLocationOrProductPages,
    findPhotosForTag,
    MMReducer,
  } = props;

  const filesToUse = forLocationOrProductPages ? findPhotosForTag : prop('media', MMReducer);
  const availableFileTypes = uniq(filesToUse.map(file => file.mediaType));
  const filteredFileType = uniq(availableFileTypes.reduce((acc, fileType) => {
    acc.push('All File Types');
    if (call(either(equals('image/jpeg'), equals('image/png')), fileType)) acc.push('Image');
    if (call(either(equals('application/vnd.ms-powerpoint'), equals('application/vnd.openxmlformats-officedocument.presentationml.presentation')), fileType)) acc.push('PowerPoint');
    if (equals(fileType, 'video/mp4')) acc.push('Video');
    if (equals(fileType, 'application/pdf')) acc.push('PDF');
    if (equals(fileType, 'CloudDrive')) acc.push('CloudDrive');
    return acc;
  }, []));

  return (
    <div>
      {
        isNilOrEmpty(filesToUse) ? <span/> :
          <DropDownMenu
            value={filterByMediaType}
            onChange={(event, index, value) => {
              const convertSelectedFilterType = notEqual(value, 'All File Types') ?
                call(cond([
                  [equals('Image'), always(['image/jpeg', 'image/png'])],
                  [equals('PowerPoint'), always(['application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation'])],
                  [equals('Video'), always(['video/mp4'])],
                  [equals('PDF'), always(['application/pdf'])],
                  [equals('CloudDrive'), always(['CloudDrive'])],
                ]), value) : filesToUse;
              if (isEditable) {
                updateMMProp({
                  filteredMedia: filesToUse.filter(file => contains(file.mediaType, convertSelectedFilterType)),
                  filterByMediaType: value,
                  searchField: '',
                });
              } else {
                updateStateForViewers('filteredMedia', filesToUse.filter(file => contains(file.mediaType, convertSelectedFilterType)));
                updateStateForViewers('filterByMediaType', value);
                updateStateForViewers('searchField', '');
              }
            }}
            underlineStyle={{ border: 'none' }}
            labelStyle={{ color: 'rgba(0, 0, 0, 0.54)' }}
            style={{ marginTop: isSupplier ? '-8px' : '' }}
          >
            {filteredFileType.map((fileType, index) => (<MenuItem key={index} value={fileType} primaryText={fileType}/>))}
          </DropDownMenu>
      }
    </div>
  );
};

Filter.propTypes = {
  updateMMProp: PropTypes.func,
  filterByMediaType: PropTypes.string,
  updateStateForViewers: PropTypes.func,
  isEditable: PropTypes.bool,
  isSupplier: PropTypes.bool,
  forLocationOrProductPages: PropTypes.bool,
  MMReducer: PropTypes.object,
  findPhotosForTag: PropTypes.array,
};

const mapStateToProps = ({ marketingMaterials }) => ({
  MMReducer: marketingMaterials.mainReducer.toJS(),
});

export default connect(mapStateToProps)(Filter);



// WEBPACK FOOTER //
// ./src/app/components/marketing-materials/title-bar/filter.jsx